module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame6.8edf3f51.png";